export const preparePlaceholdersDatasets = (
    allPlaceholders = { items: [] },
    detectedPlaceholders = [],
    dbPlaceholderRefs = { items: [] },
) => {
    const detectedPlaceholdersGroupNames = new Set(detectedPlaceholders.map((item) => item.group));
    const placeholderGroupsUsed = allPlaceholders.items.filter((placeholderGroup) =>
        detectedPlaceholdersGroupNames.has(placeholderGroup.name),
    );
    const usedDefinitionIds = new Set(
        placeholderGroupsUsed.map((placeholderGroup) => placeholderGroup.placeholderDefinitionId),
    );
    const dbPlaceholderRefsByDefinitionId = new Map(
        dbPlaceholderRefs.items.map((item) => [item.placeholderDefinitionId, item]),
    );

    return {
        save: placeholderGroupsUsed.filter(
            (placeholderGroup) =>
                !dbPlaceholderRefsByDefinitionId.has(placeholderGroup.placeholderDefinitionId),
        ),
        remove: dbPlaceholderRefs.items.filter(
            (item) => !usedDefinitionIds.has(item.placeholderDefinitionId),
        ),
    };
};

export const usePlaceholderSync = () => {
    return {
        preparePlaceholdersDatasets: preparePlaceholdersDatasets,
    };
};

export default usePlaceholderSync;
